import {
    AfterViewInit,
    ChangeDetectionStrategy,
    Component,
    inject,
    PLATFORM_ID,
    signal,
    ViewEncapsulation,
} from '@angular/core';
import { ClickOutsideDirective } from '@shared/click-outside/click-outside.directive';
import { ChevronComponent } from '@shared/chevron/chevron.component';
import { Locales } from '@shared/language-switcher/language-switcher.type';
import { isPlatformBrowser, LocationStrategy } from '@angular/common';
import { locales } from '../../../locale/locale';

@Component({
    selector: 'companyid-language-switcher',
    imports: [ClickOutsideDirective, ChevronComponent],
    templateUrl: './language-switcher.component.html',
    styleUrl: './language-switcher.component.scss',
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LanguageSwitcherComponent implements AfterViewInit {
    public language = signal<string>('');
    public isShown = signal<boolean>(false);
    public readonly locales: Locales[] = locales;

    private readonly platformId = inject<string>(PLATFORM_ID);
    private readonly baseHref = inject(LocationStrategy).getBaseHref().slice(1, -1);

    public toggle(): void {
        this.isShown.set(!this.isShown());
    }

    public ngAfterViewInit(): void {
        if (!isPlatformBrowser(this.platformId)) {
            return;
        }
        this.setInitialLanguage();
    }

    public chooseLanguage(locale: Locales): void {
        this.changeLocationPath(locale);
        this.toggle();
    }

    private setInitialLanguage(): void {
        const matchingLocale = this.locales.find((locale) => locale.code === this.baseHref);
        if (!matchingLocale) {
            return;
        }
        this.changeLocationPath(matchingLocale);
    }

    private changeLocationPath(locale: Locales): void {
        this.language.set(locale.label);
        if (this.baseHref.startsWith(locale.code)) {
            return;
        }

        window.location.pathname = window.location.pathname.replace(`/${this.baseHref}`, `/${locale.code}`);
    }
}
